import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import { SafePipe } from "../../../helpers/safepipe/safepipe";
import { ServiceIcon } from "../service-icon/service-icon";

@Component({
  selector: "empty-state",
  templateUrl: "empty-state.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule, SafePipe, ServiceIcon],
})
export class EmptyState {
  title = input.required<string>();
  icons = input.required<string[]>();
}
